import { createContext, useContext } from 'react';

/** true khi trang đang được render bên trong một tab của TabbedPage. */
export const EmbeddedContext = createContext(false);

export const useIsEmbedded = () => useContext(EmbeddedContext);
